module.exports = __webpack_public_path__ + "static/todCostofServiceSpanish-883c6faf3ab0017fde6d32140147397e.png";